import React, { useMemo, forwardRef } from 'react';
import Type from 'prop-types';
import { Tab } from "@mui/material";
import Link from '../Link';

const TabLink = (props) => {
  const { to, ...other } = props;

  const renderLink = useMemo(
    () => forwardRef((linkProps, ref) => <Link to={to} {...linkProps} ref={ref} />),
    [to],
  );

  return <Tab component={renderLink} {...other} />;
};

TabLink.propTypes = {
  to: Type.oneOfType([Type.string, Type.object, Type.func]).isRequired,
};

export default TabLink;
